import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



// Parameter bisa nomor halaman (perilaku lama) atau objek { page, type, q }.
export const getDocumentlainContent = createAsyncThunk('/documentlain/content', async (arg) => {
    const userId = localStorage.getItem("userId")
    const opts = (arg !== null && typeof arg === 'object') ? arg : { page: arg }
    const params = new URLSearchParams()
    params.set('page', opts.page ?? '')
    if (opts.type) params.set('type', opts.type)
    if (opts.q) params.set('q', opts.q)
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanyOtherFile/${userId}?${params.toString()}`, {})
    return response.data;
})

export const documentlainSlice = createSlice({
    name: 'documentlain',
    initialState: {
        isLoading: false,
        documentlain : [],
        summary: null,
        meta: null
    },
    reducers: {


        addNewDocumentlain: (state, action) => {
            let {newDocumentlainObj} = action.payload
            state.documentlain = [...state.documentlain, newDocumentlainObj]
        },

        deleteDocumentlain: (state, action) => {
            let {index} = action.payload
            state.documentlain.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getDocumentlainContent.pending]: state => {
			state.isLoading = true
		},
        [getDocumentlainContent.fulfilled]: (state, action) => {
            state.documentlain = action.payload.data
			state.isLoading = false
		},
        [getDocumentlainContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getDocumentlainContent.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getDocumentlainContent.fulfilled, (state, action) => {
            state.documentlain = action.payload.data;
            state.summary = action.payload.summary || null;
            state.meta = action.payload.meta_data || null;
            state.isLoading = false;
          })
          .addCase(getDocumentlainContent.rejected, (state) => {
            state.isLoading = false;
          });
      }
})

export const { addNewDocumentlain, deleteDocumentlain } = documentlainSlice.actions

export default documentlainSlice.reducer